import getAvailableFeatures from './getAvailableFeatures';
import ToasterService from '../ToasterService';
import tierMessages from '../../const/tierMessages';
import environmentNames from '../../const/environmentNames';

function canChangeEnvironment(tier, environment) {
    const availableFeatures = getAvailableFeatures(tier);
    if (!availableFeatures.environments.includes(environment)) {
        ToasterService.showInfo({
            title: tierMessages.environmentIsUnavailable(environmentNames[environment]),
        });
        return false;
    }
    return true;
}

export default canChangeEnvironment;
